import { z } from 'zod';

// Service points: the places a patient queues for (triage, a consultation room, the lab).
// Master data per facility (docs/plans/phase1-registration.md §2.11).

export const SERVICE_POINT_KINDS = [
  'triage',
  'consultation',
  'lab',
  'pharmacy',
  'cashier',
  'other',
  // Casualty (docs/plans/phase2-casualty.md §1.1): opens emergency visits.
  'casualty',
] as const;
export type ServicePointKind = (typeof SERVICE_POINT_KINDS)[number];

export const servicePointSchema = z.object({
  id: z.uuid(),
  facilityId: z.uuid(),
  name: z.string(),
  kind: z.enum(SERVICE_POINT_KINDS),
  status: z.enum(['active', 'inactive']),
  sortOrder: z.number().int(),
  /** The consultation fee charged at check-in here (billing plan §4.1); null for none. */
  chargeServiceItemId: z.uuid().nullable(),
});

export type ServicePointView = z.infer<typeof servicePointSchema>;

export const servicePointInputSchema = z.object({
  name: z.string().trim().min(1).max(80),
  kind: z.enum(SERVICE_POINT_KINDS),
  sortOrder: z.number().int().min(0).max(10_000).default(0),
});

/** Only the fields sent change. Deactivating hides it from check-in; nothing is deleted. */
export const updateServicePointRequestSchema = z.object({
  name: z.string().trim().min(1).max(80).optional(),
  kind: z.enum(SERVICE_POINT_KINDS).optional(),
  status: z.enum(['active', 'inactive']).optional(),
  sortOrder: z.number().int().min(0).max(10_000).optional(),
});
